import { ParameterizedCollection } from "common/collections/parameterizedCollection";
import * as _transformers from "common/collections/_transformers";

export const ParameterizedTransformCollection = ParameterizedCollection.extend({
    ..._transformers,
    
    setQualifiers(qualifiers) {
        this.setQueryParam({
            q: qualifiers.toString()
        });

        return this;
    }
});
